import { render, staticRenderFns } from "./PartnersFooter.vue?vue&type=template&id=d66bf10a&scoped=true"
var script = {}
import style0 from "./PartnersFooter.vue?vue&type=style&index=0&id=d66bf10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66bf10a",
  null
  
)

export default component.exports